<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .attendee {
    align-items: center;
    display: flex;
    justify-content: space-between;

    .attendee-info {
      align-items: center;
      display: flex;
      gap: utils.in_rem(8px);

      .attendee-details {
        display: flex;
        flex-direction: column;
        line-height: 1.2;

        .name {
          @include mixins.h4;
          color: colors.get(textWhite);
          white-space: nowrap;
        }

        .phone {
          @include mixins.body4;
          color: colors.get(textWhite);
          white-space: nowrap;
        }

        .subText {
          @include mixins.body4;
          color: colors.get(interfaceTransparentWhite_70);
          white-space: nowrap;
        }
      }
    }

    .duration {
      @include mixins.body4;
      color: colors.get(textWhite);
      font-weight: 400;
      white-space: nowrap;
    }
  }
</style>

<script>
  import DiallerAvatar from "./DiallerAvatar.svelte";

  let { attendee } = $props();

  const isTeammate = $derived(attendee.role === "teammate");
  const notJoined = $derived(
    isTeammate &&
      (attendee.inviteStatus === "pending" ||
        attendee.inviteStatus === "declined")
  );

  const subText = $derived(
    isTeammate &&
      (attendee.inviteStatus === "pending"
        ? "Has been invited..."
        : "Has declined the invite...")
  );
</script>

<div class="attendee">
  <div class="attendee-info">
    <DiallerAvatar
      firstName={attendee.firstName || attendee.name.split(" ")[0]}
      lastName={attendee.lastName ||
        attendee.name.split(" ").slice(1).join(" ")}
      size="small"
      state={attendee.role}
      modeIcon={attendee.modeIcon}
    />
    <div class="attendee-details">
      <div class="name">
        {attendee.firstName || attendee.lastName
          ? `${attendee.firstName} ${attendee.lastName}`
          : attendee.name || "Unknown"}
      </div>
      {#if notJoined}
        <div class="subText">{subText}</div>
      {/if}
      {#if attendee.phone}
        <div class="phone">{attendee.phone}</div>
      {/if}
      <div class="subText">
        {#if attendee.jobTitle && attendee.company}
          {attendee.jobTitle} @ {attendee.company}
        {:else}
          {attendee.company || attendee.jobTitle || ""}
        {/if}
      </div>
    </div>
  </div>
</div>
